module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-floral-3-188a6bda0634a01c471f2b070b0fab33.webp";